import React, {useEffect, useState} from "react";
import SkillpacaApi from "../services/SkillpacaApi";
import FullScreenLoading from "./util/FullScreenLoading";
import {useNavigate} from "react-router-dom";
import LogoutButton from "./util/LogoutButton";

const skillpacaApi = SkillpacaApi();

export default function Home() {

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        skillpacaApi.getSurveys().then(surveys => {
            console.log(surveys)
            if (surveys && Array.isArray(surveys)) {
                navigate('/overview/' + surveys[0].id)
            } else {
                setIsLoading(false)
            }
        }).catch(err => {
            console.error(err)
            setIsLoading(false)
        })
    }, [navigate])

    if (isLoading) {
        return (
            <FullScreenLoading/>
        )
    }

    return (
        <div>
            <p>Could not find any surveys in your tenant</p>
            <LogoutButton/>
        </div>
    )
}
